import {
  FETCH_DETAIL_NFA_INIT,
  FETCH_DETAIL_NFA_SUCCESS,
  FETCH_DETAIL_NFA_FAILURE,
  FETCH_DETAIL_NFA_BPM_INIT,
  FETCH_DETAIL_NFA_BPM_SUCCESS,
  FETCH_DETAIL_NFA_BPM_FAILURE,
  FETCH_DETAIL_NFA_RANKING_INIT,
  FETCH_DETAIL_NFA_RANKING_SUCCESS,
  FETCH_DETAIL_NFA_RANKING_FAILURE,
  FETCH_DETAIL_NFA_RANKING_NO_LOADING_INIT,
  FETCH_DETAIL_NFA_RANKING_NO_LOADING_SUCCESS,
  FETCH_DETAIL_NFA_RANKING_NO_LOADING_FAILURE,
  FETCH_DETAIL_NFA_RANKING_COUNT_INIT,
  FETCH_DETAIL_NFA_RANKING_COUNT_SUCCESS,
  FETCH_DETAIL_NFA_RANKING_COUNT_FAILURE,
  SET_FILTER_DETAIL_NFA,
  RESET_DETAIL_NFA,
  FETCH_DETAIL_NFA_MODAL_EVOLUTION_INIT,
  FETCH_DETAIL_NFA_MODAL_EVOLUTION_SUCCESS,
  FETCH_DETAIL_NFA_MODAL_EVOLUTION_FAILURE,
  FETCH_DETAIL_NFA_MODAL_TABLE_INIT,
  FETCH_DETAIL_NFA_MODAL_TABLE_SUCCESS,
  FETCH_DETAIL_NFA_MODAL_TABLE_FAILURE,
  FETCH_DETAIL_NFA_MODAL_EVOLUTION_FILTER_INIT,
  FETCH_DETAIL_NFA_MODAL_EVOLUTION_FILTER_SUCCESS,
  FETCH_DETAIL_NFA_MODAL_EVOLUTION_FILTER_FAILURE,
  FETCH_DETAIL_NFA_MODAL_TABLE_COUNT_INIT,
  FETCH_DETAIL_NFA_MODAL_TABLE_COUNT_SUCCESS,
  FETCH_DETAIL_NFA_MODAL_TABLE_COUNT_FAILURE,
  FETCH_DETAIL_NFA_MODAL_TABLE_NO_LOADING_INIT,
  FETCH_DETAIL_NFA_MODAL_TABLE_NO_LOADING_SUCCESS,
  FETCH_DETAIL_NFA_MODAL_TABLE_NO_LOADING_FAILURE
} from './types';
import API from './api';

/* Actions Creators */

export function setFilterDetailNfa(obj) {
  return {
    type: SET_FILTER_DETAIL_NFA,
    payload: obj
  };
}

export function resetDetailNfa() {
  return {
    type: RESET_DETAIL_NFA
  };
}

/* Get */
function fetchApiSuccess(data) {
  return {
    type: FETCH_DETAIL_NFA_SUCCESS,
    payload: data
  };
}

function fetchApiFailure(error) {
  return {
    type: FETCH_DETAIL_NFA_FAILURE,
    payload: error
  };
}

function fetchApiInit() {
  return {
    type: FETCH_DETAIL_NFA_INIT
  };
}

export function fetchDetailNfaApi(obj) {
  return async dispatch => {
    dispatch(fetchApiInit());
    try {
      let data = await API.data.getAll(obj);
      dispatch(fetchApiSuccess(data));
    } catch (error) {
      dispatch(fetchApiFailure(error));
    }
  };
}

/* Get BPM */
function fetchApiBPmSuccess(data) {
  return {
    type: FETCH_DETAIL_NFA_BPM_SUCCESS,
    payload: data
  };
}

function fetchApiBpmFailure(error) {
  return {
    type: FETCH_DETAIL_NFA_BPM_FAILURE,
    payload: error
  };
}

function fetchApiBpmInit() {
  return {
    type: FETCH_DETAIL_NFA_BPM_INIT
  };
}

export function fetchDetailNfaBPMApi(obj) {
  return async dispatch => {
    dispatch(fetchApiBpmInit());
    try {
      let data = await API.data.getBPM(obj);
      dispatch(fetchApiBPmSuccess(data));
    } catch (error) {
      dispatch(fetchApiBpmFailure(error));
    }
  };
}
/* Get Ranking */
function fetchApiRankingSuccess(data) {
  return {
    type: FETCH_DETAIL_NFA_RANKING_SUCCESS,
    payload: data
  };
}

function fetchApiRankingFailure(error) {
  return {
    type: FETCH_DETAIL_NFA_RANKING_FAILURE,
    payload: error
  };
}

function fetchApiRankingInit() {
  return {
    type: FETCH_DETAIL_NFA_RANKING_INIT
  };
}

export function fetchDetailNfaRankingApi(obj) {
  return async dispatch => {
    dispatch(fetchApiRankingInit());
    try {
      let data = await API.data.getRanking(obj);
      dispatch(fetchApiRankingSuccess(data));
    } catch (error) {
      dispatch(fetchApiRankingFailure(error));
    }
  };
}

/* Get Ranking No loading */
function fetchApiRankingNoLoadingSuccess(data, concat) {
  return {
    type: FETCH_DETAIL_NFA_RANKING_NO_LOADING_SUCCESS,
    payload: data,
    concat
  };
}

function fetchApiRankingNoLoadingFailure(error) {
  return {
    type: FETCH_DETAIL_NFA_RANKING_NO_LOADING_FAILURE,
    payload: error
  };
}

function fetchApiRankingNoLoadingInit() {
  return {
    type: FETCH_DETAIL_NFA_RANKING_NO_LOADING_INIT
  };
}

export function fetchDetailNfaRankingNoLoadingApi(obj) {
  return async dispatch => {
    dispatch(fetchApiRankingNoLoadingInit());
    try {
      let data = await API.data.getRanking(obj);
      dispatch(fetchApiRankingNoLoadingSuccess(data, obj.concat));
    } catch (error) {
      dispatch(fetchApiRankingNoLoadingFailure(error));
    }
  };
}

/* Get Ranking Count */
function fetchApiRankingCountSuccess(data) {
  return {
    type: FETCH_DETAIL_NFA_RANKING_COUNT_SUCCESS,
    payload: data
  };
}

function fetchApiRankingCountFailure(error) {
  return {
    type: FETCH_DETAIL_NFA_RANKING_COUNT_FAILURE,
    payload: error
  };
}

function fetchApiRankingCountInit() {
  return {
    type: FETCH_DETAIL_NFA_RANKING_COUNT_INIT
  };
}

export function fetchDetailNfaRankingCountApi(obj) {
  return async dispatch => {
    dispatch(fetchApiRankingCountInit());
    try {
      let data = await API.data.getCount(obj);
      dispatch(fetchApiRankingCountSuccess(data));
    } catch (error) {
      dispatch(fetchApiRankingCountFailure(error));
    }
  };
}

/* Get modal evolution */
function fetchApiModalEvolutionSuccess(data) {
  return {
    type: FETCH_DETAIL_NFA_MODAL_EVOLUTION_SUCCESS,
    payload: data
  };
}

function fetchApiModalEvolutionFailure(error) {
  return {
    type: FETCH_DETAIL_NFA_MODAL_EVOLUTION_FAILURE,
    payload: error
  };
}

function fetchApiModalEvolutionInit() {
  return {
    type: FETCH_DETAIL_NFA_MODAL_EVOLUTION_INIT
  };
}

export function fetchDetailNfaModalEvolutionApi(obj) {
  return async dispatch => {
    dispatch(fetchApiModalEvolutionInit());
    try {
      let data = await API.data.getModalEvolution(obj);
      dispatch(fetchApiModalEvolutionSuccess(data));
    } catch (error) {
      dispatch(fetchApiModalEvolutionFailure(error));
    }
  };
}

/* Get  Modal Evolution Filter */
function fetchApiModalEvolutionFilterSuccess(data) {
  return {
    type: FETCH_DETAIL_NFA_MODAL_EVOLUTION_FILTER_SUCCESS,
    payload: data
  };
}

function fetchApiModalEvolutionFilterFailure(error) {
  return {
    type: FETCH_DETAIL_NFA_MODAL_EVOLUTION_FILTER_FAILURE,
    payload: error
  };
}

function fetchApiModalEvolutionFilterInit() {
  return {
    type: FETCH_DETAIL_NFA_MODAL_EVOLUTION_FILTER_INIT
  };
}

export function fetchDetailNfaModalEvolutionFilterApi(obj) {
  return async dispatch => {
    dispatch(fetchApiModalEvolutionFilterInit());
    try {
      let data = await API.data.getModalEvolutionFilter(obj);
      dispatch(fetchApiModalEvolutionFilterSuccess(data));
    } catch (error) {
      dispatch(fetchApiModalEvolutionFilterFailure(error));
    }
  };
}

/* Get  Modal  table count */
function fetchApiModalTableCountSuccess(data) {
  return {
    type: FETCH_DETAIL_NFA_MODAL_TABLE_COUNT_SUCCESS,
    payload: data
  };
}

function fetchApiModalTableCountFailure(error) {
  return {
    type: FETCH_DETAIL_NFA_MODAL_TABLE_COUNT_FAILURE,
    payload: error
  };
}

function fetchApiModalTableCountInit() {
  return {
    type: FETCH_DETAIL_NFA_MODAL_TABLE_COUNT_INIT
  };
}

export function fetchDetailNfaModalTableCountApi(obj) {
  return async dispatch => {
    dispatch(fetchApiModalTableCountInit());
    try {
      let data = await API.data.getModalTableCount(obj);
      dispatch(fetchApiModalTableCountSuccess(data));
    } catch (error) {
      dispatch(fetchApiModalTableCountFailure(error));
    }
  };
}

/* Get modal table */
function fetchApiModalTableSuccess(data) {
  return {
    type: FETCH_DETAIL_NFA_MODAL_TABLE_SUCCESS,
    payload: data
  };
}

function fetchApiModalTableFailure(error) {
  return {
    type: FETCH_DETAIL_NFA_MODAL_TABLE_FAILURE,
    payload: error
  };
}

function fetchApiModalTableInit() {
  return {
    type: FETCH_DETAIL_NFA_MODAL_TABLE_INIT
  };
}

export function fetchDetailNfaModalTableApi(obj) {
  return async dispatch => {
    dispatch(fetchApiModalTableInit());
    try {
      let data = await API.data.getModalTable(obj);
      dispatch(fetchApiModalTableSuccess(data));
    } catch (error) {
      dispatch(fetchApiModalTableFailure(error));
    }
  };
}

/* Get table modal No loading */
function fetchApiModalTableNoLoadingSuccess(data, concat) {
  return {
    type: FETCH_DETAIL_NFA_MODAL_TABLE_NO_LOADING_SUCCESS,
    payload: data,
    concat
  };
}

function fetchApiModalTableNoLoadingFailure(error) {
  return {
    type: FETCH_DETAIL_NFA_MODAL_TABLE_NO_LOADING_FAILURE,
    payload: error
  };
}

function fetchApiModalTableNoLoadingInit() {
  return {
    type: FETCH_DETAIL_NFA_MODAL_TABLE_NO_LOADING_INIT
  };
}

export function fetchDetailNfaModalTableNoLoadingApi(obj) {
  return async dispatch => {
    dispatch(fetchApiModalTableNoLoadingInit());
    try {
      let data = await API.data.getModalTable(obj);
      dispatch(fetchApiModalTableNoLoadingSuccess(data, obj.concat));
    } catch (error) {
      dispatch(fetchApiModalTableNoLoadingFailure(error));
    }
  };
}



// WEBPACK FOOTER //
// ./source/client/actions/detail_nfa/index.js